export default "<p>test-component works!</p>\n"